import { MCard, MCheckboxGroup, MSpinner } from "components/Shared";
import { MCheckboxGroupOption } from "components/Shared/MCheckboxGroup";
import { RecommendationResult } from "interfaces/Mueller.Business.Models";
import React from "react";

interface CustomizeRecommendationsCardProps {
  recommendations: RecommendationResult[];
  onRecommendationsChange: (recommendations: RecommendationResult[]) => void;
  isFetching: boolean;
}

// This is a managed component, recommendations need to be passed in and changes communicated via onRecommendationsChange
const CustomizeRecommendationsCard = ({
  recommendations,
  onRecommendationsChange,
  isFetching,
}: CustomizeRecommendationsCardProps) => {
  
  if (isFetching) {
    return <MSpinner />;
  }

  if (recommendations.length === 0) {
    return <MCard title="Customize Recommendations" children={<div>No recommendations available</div>}/>;
  }

  // React nodes work fine for the label
  //@ts-ignore
  const checkboxGroupFields: MCheckboxGroupOption[] = recommendations.map((rec) => ({
    // Manual recs really don't have any sort of unique identifier, so I'm throwing the location in there I guess?
    // I can't imagine we would ever have two of the same exact recs in the same location
    value: `${rec.category}-${rec.name}-${rec.location}`,
    label: <>{rec.name} <br /> {rec.recommendation}</>,
    checked: rec.include === "1",
  }));

  const onCheckedChange = (value: string, checked: boolean) => {
    const updatedRecs = recommendations.map((rec) =>
      `${rec.category}-${rec.name}-${rec.location}` === value ? { ...rec, include: checked ? "1" : "" } : rec,
    );
    onRecommendationsChange(updatedRecs);
  };

  const cardContent = (
    <>
      <div>Uncheck any recommendations you wish to exclude from the rec letter:</div>
      <MCheckboxGroup fields={checkboxGroupFields} onChange={onCheckedChange} containerClassName="customize-recs-control" gridClassname="customize-recs-grid"/>
    </>
  );

  return <MCard title="Customize Recommendations" children={cardContent} />;
};

export default CustomizeRecommendationsCard;
